import { useEffect, useRef } from "react";
import {
	useDispatch as useDispachRedux,
	useSelector as useSelectorRedux,
} from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";

import type { RootState, AppDispatch } from "../store";

interface UseEventListenerPropsI {
	type: string;
	handler: (data: any) => void;
	withData?: boolean;
}

export const useEventListener = ({
	type,
	handler,
	withData = false,
}: UseEventListenerPropsI) => {
	const savedHandler = useRef(null);

	useEffect(() => {
		savedHandler.current = handler;
	}, [handler]);

	useEffect(() => {
		const listener = (event) =>
			savedHandler.current(withData ? { ...event.detail } : event);

		document.addEventListener(type, listener);

		return () => {
			document.removeEventListener(type, listener);
		};
	}, [type]);
};

export const useDispatch: () => AppDispatch = useDispachRedux;
export const useSelector: TypedUseSelectorHook<RootState> = useSelectorRedux;
